import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c59a2bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "custom-tabs-label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-cog fas" }, null, -1))
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_station_image_component = _resolveComponent("station-image-component")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_station_images_modal_component = _resolveComponent("station-images-modal-component")!
  const _component_camera_form = _resolveComponent("camera-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.stationEntity.stationsCamera && _ctx.stationEntity.stationsCamera.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.editableTabsValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editableTabsValue) = $event)),
            type: "card",
            class: "demo-tabs",
            onTabChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getLastImage()))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stationEntity.stationsCamera, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: item,
                  name: item
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                      _createTextVNode(_toDisplayString(item.camera.code) + _toDisplayString(item.numCamera) + " ", 1),
                      _createVNode(_component_el_button, {
                        onClick: ($event: any) => (_ctx.editConfiguration(item)),
                        circle: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "image-col",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.seeImages()))
                    }, [
                      _createVNode(_component_station_image_component, {
                        images: [_ctx.lastImageCamera]
                      }, null, 8, ["images"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "image-col",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.seeImages()))
          }, [
            _createVNode(_component_station_image_component, {
              images: [_ctx.lastImage]
            }, null, 8, ["images"])
          ])
        ])),
    (_ctx.isModalImageVisible)
      ? (_openBlock(), _createBlock(_component_station_images_modal_component, {
          key: 2,
          title: _ctx.$t('label.imageViewer'),
          stationId: _ctx.stationEntity.station,
          camera: _ctx.editableTabsValue?.camera?.code ? _ctx.editableTabsValue.camera.code : '',
          onClose: _ctx.closeModalImage
        }, null, 8, ["title", "stationId", "camera", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isModalCameraVisible)
      ? (_openBlock(), _createBlock(_component_camera_form, {
          key: 3,
          title: _ctx.camera,
          configuration: _ctx.configurationCamera,
          onClose: _ctx.closeModalCamera,
          data: _ctx.cameraConfigTest
        }, null, 8, ["title", "configuration", "onClose", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}